module.exports = __webpack_public_path__ + "media/newstyle/images/assistente-de-ia-d3c042b9a5330f624d546b4cad526e9a.png";